import React from "react";
import { DescriptionBody, TitleBody } from ".."
import { Header } from "./style"

interface Props {
    title: string;
    description: string;
}

export const HeaderDash: React.FC<Props> = ({ title, description }) => {
    return (
        <Header>
            <TitleBody>{title}</TitleBody>
            <DescriptionBody>{description}</DescriptionBody>
        </Header>
    )
}